// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.modal_size {
  width: 50vw;
}
@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .modal_size {
    width: 65vw;
  }
}

.manager_modal_size {
  width: 65vw;
}
@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .manager_modal_size {
    width: 80vw;
  }
}

.m_conf {
  min-width: initial;
}

.brand_mng {
  display: flex;
  justify-content: end;
}

.main_registr_fields {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 0.6em;
}

.selects {
  display: flex;
  flex-direction: row;
  justify-content: start;
}

.buttons_mng_reg {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.btns_t {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 2em;
}

.glowing-border {
  border-radius: 2em; /* Скругленные углы */
  padding: 0px;
  margin: 1px 6px;
  box-shadow: 0 0 10px rgba(16, 57, 100, 0.7), 0 0 15px rgba(0, 123, 255, 0.5), 0 0 20px rgba(0, 123, 255, 0.3);
}

.noBorderBox {
  box-sizing: content-box !important;
}

.noBorderBox::before,
::after {
  box-sizing: content-box !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/SamplesList/SampleModals/mngRegistr.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;AAEF;AADE;EAFF;IAGI,WAAA;EAIF;AACF;;AADA;EACE,WAAA;AAIF;AAHE;EAFF;IAGI,WAAA;EAMF;AACF;;AAHA;EACE,kBAAA;AAMF;;AAHA;EACE,aAAA;EACA,oBAAA;AAMF;;AAHA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAMF;;AAHA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAMF;;AAHA;EAEE,kBAAA,EAAA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,6GAAA;AAKF;;AADA;EACE,kCAAA;AAIF;;AAFA;;EAEE,kCAAA;AAKF","sourcesContent":[".modal_size {\n  width: 50vw;\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 65vw;\n  }\n}\n\n.manager_modal_size {\n  width: 65vw;\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 80vw;\n  }\n}\n\n.m_conf {\n  min-width: initial;\n}\n\n.brand_mng {\n  display: flex;\n  justify-content: end;\n}\n\n.main_registr_fields {\n  width: 100%;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: start;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 0.6em;\n}\n\n.selects {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n}\n\n.buttons_mng_reg {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.btns_t {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin-bottom: 2em;\n}\n\n.glowing-border {\n  // border: 2px solid transparent; /* Изначально прозрачная граница */\n  border-radius: 2em; /* Скругленные углы */\n  padding: 0px;\n  margin: 1px 6px;\n  box-shadow: 0 0 10px rgba(16, 57, 100, 0.7), /* Цвет свечения */ 0 0 15px rgba(0, 123, 255, 0.5),\n    0 0 20px rgba(0, 123, 255, 0.3);\n}\n\n.noBorderBox {\n  box-sizing: content-box !important;\n}\n.noBorderBox::before,\n::after {\n  box-sizing: content-box !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
